import Colours from '../definitions/Colours';


const CARD_BANNER_VARIANTS = {
    giftOffer: 'gift-offer',
    referralOffer: 'referral-offer',
};

const CARD_BANNER_COLOURS = {
    [CARD_BANNER_VARIANTS.giftOffer]: {
        background: 'rh-bg-grape-lightest',
        textColour: 'rh-fg-blackberry',
        stroke: Colours.GRAPE_DARK,
    },

    [CARD_BANNER_VARIANTS.referralOffer]: {
        background: 'rh-bg-stone-lightest',
        textColour: 'rh-fg-blackberry-light',
        stroke: Colours.BLACKBERRY_LIGHT,
    },
};


export { CARD_BANNER_VARIANTS };
export default CARD_BANNER_COLOURS;
